export const dashboardEndpoints = {
  count: '/admin/stats/count', // GET
  overview: '/admin/stats/overview', // GET
  onlinePlayers: '/admin/stats/online-players', // GET
}

// How often the live player count re-polls the backend (ms).
export const ONLINE_PLAYERS_REFETCH_MS = 10_000
